// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetMarketTrandResponseSchema } from '../../entities/market_trand/GetMarketTrandResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetMarketTrandRequest {
  /** Код дома геокодера **/
  realtyId: number;
  /** Фильтр количество комнат **/
  roomsCount: ERoomsCount;
  /** Фильтр Период **/
  period: EPeriod;
}
export enum ERoomsCount {
  /** Все квартиры **/
  'All' = 'all',
  /** Четырехкомнатная квартира + другие **/
  'FourPlusRooms' = 'fourPlusRooms',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Трехкомнатная квартира **/
  'ThreeRooms' = 'threeRooms',
  /** Двухкомнатная квартира **/
  'TwoRooms' = 'twoRooms',
}
export enum EPeriod {
  'All' = 'all',
  'OneMonth' = 'oneMonth',
  'OneYear' = 'oneYear',
  'SixMonths' = 'sixMonths',
  'TwoYears' = 'twoYears',
}

export type IGetMarketTrandResponse = IGetMarketTrandResponseSchema;

export interface IGetMarketTrandResponse200 extends IModelResponse<IGetMarketTrandResponse> {
  statusCode: 200;
}

export type IGetMarketTrandResponseError = IErrorResponseSchema;

export interface IGetMarketTrandResponse400 extends IModelResponse<IGetMarketTrandResponseError> {
  statusCode: 400;
}

export type TGetMarketTrandResponse = IGetMarketTrandResponse200 | IGetMarketTrandResponse400;

export type TGetMarketTrandModel = IModel<IGetMarketTrandRequest, TGetMarketTrandResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetMarketTrandResponse): TResponse200;
  400(response: IGetMarketTrandResponseError): TResponse400;
}
